export const ROOT = "/";
export const EXPERIENCES = "/experiences";
